<app-loading-component [isLoading]="isLoading">
  <div class="step-container">
    <p-steps
      [model]="items"
      [(activeIndex)]="activeIndex"
      [readonly]="true"
      class="stepper"
    ></p-steps>

    <!--    Admin login-->
    @if (activeIndex === 0) {
      <div class="step-content">
        <div class="subheading">Connexion sécurisée à Google Workspace</div>
        <div class="main-heading">
          Nous allons demander une autorisation d'accès limitée pour activer
          Overlayer.
        </div>
        <div class="description">
          Nous avons besoin de créer un utilisateur technique et un rôle
          personnalisé pour gérer vos labels et automatiser vos processus.
        </div>
        <ul class="description" style="list-style-type: none">
          <li>✅ Accès limité et sécurisé</li>
          <li>✅ Aucun impact sur les utilisateurs existants</li>
          <li>✅ Modifiable à tout moment</li>
        </ul>
        <p-button
          label="🔐 Se connecter en tant qu'administrateur Google Workspace"
          severity="contrast"
          (onClick)="checkUserRoleAndRedirect()"
        ></p-button>
      </div>
    }

    <!--    Dedicated user creation and login -->
    @if (activeIndex === 1) {
      <div class="step-content">
        <div class="main-heading">Connexion à l’utilisateur technique 🔐</div>
        <div class="description">
          Nous avons créé un utilisateur technique dédié {{ clientEmail }} qui
          sera utilisé par Overlayer pour gérer vos labels et automatisations.
          Pour finaliser la configuration, connectez-vous avec cet utilisateur
          en utilisant le mot de passe temporaire ci-dessous.
        </div>
        @if (!isServiceAccountInCreation()) {
          <div class="description">
            <label for="email">Email: </label>
            <input type="email" pInputText [(ngModel)]="clientEmail" />

            <label class="password" for="password">Mot de passe: </label>
            <p-password
              [(ngModel)]="clientPassword"
              [disabled]="true"
              placeholder="**********"
            ></p-password>

            <p-button
              icon="pi pi-copy"
              [rounded]="true"
              [text]="true"
              (click)="copyPassword()"
              class="copy-button"
            ></p-button>
          </div>

          @if (!isAccountCreationInProgress) {
            <p-button
              label="🔐 Se connecter avec l’utilisateur technique"
              severity="contrast"
              (onClick)="createDedicatedUserAndLogin()"
              class="login-button"
              [disabled]="!pwdCopied && !isServiceAccountInCreation()"
            ></p-button>
          }

          @if (!pwdCopied && !isServiceAccountInCreation) {
            <p style="color: red">
              Vous devez copier les informations de connexion (e-mail + mot de
              passe) ci-dessus pour pouvoir passer à l'étape suivante.
            </p>
          }
        } @else {
          <p>
            Nous avons detecté que l'utilisateur technique a déjà été crée.
            Connectez-vous avec le compte précédemment créé en utilisant le mot
            de passe précédemment fourni.
          </p>

          <p-button
            label="🔐 Se connecter avec l’utilisateur technique"
            severity="contrast"
            (onClick)="loginAsDedicatedUser()"
            class="login-button"
          ></p-button>
        }

        @if (isAccountCreationInProgress) {
          <div>
            <p-progressSpinner
              ariaLabel="loading"
              class="top-drive-spinner"
            ></p-progressSpinner>
          </div>
        }
      </div>
    }

    <!--    Labels and others steps as dedicated user-->
    @if (activeIndex >= 2) {
      <div class="step-content">
        <div class="main-heading">Créer les labels Google nécessaires</div>
        <div class="description">
          Overlayer va créer automatiquement les labels qui seront utilisées
          pour organiser vos documents et gérer les workflows.
        </div>
        <ul class="description" style="list-style-type: none">
          <li>✅ Les labels sont créées dans votre domaine Google Workspace</li>
          <li>✅ Aucun impact sur vos documents existants</li>
        </ul>
        @if (!isInstallingOnSharedDrives) {
          <div>
            @if (driveSelectionDisabled) {
              <p-progressSpinner ariaLabel="loading" class="top-drive-spinner">
              </p-progressSpinner>
            } @else {
              <p-button
                label="🎯 Créer les labels Overlayer"
                severity="contrast"
                (onClick)="navigateToSettings()"
              >
              </p-button>
            }
          </div>
        }
        @if (isInstallingOnSharedDrives) {
          <p-progressSpinner ariaLabel="loading" class="top-drive-spinner">
          </p-progressSpinner>
        }
      </div>
    }
  </div>
  <p-dialog
    header="Choisissez le nom du client"
    [(visible)]="openDialogs.createDedicatedAccount"
    [modal]="true"
    [draggable]="false"
    [style]="{ width: '40%' }"
  >
    <input
      type="text"
      pInputText
      [(ngModel)]="clientLabel"
      [style]="{ width: '100%' }"
    />

    <p-footer>
      <p-button
        label="Annuler"
        icon="pi pi-times"
        class="p-button-secondary"
        severity="contrast"
        (click)="toggleDialog('createDedicatedAccount', false)"
      ></p-button>
      <p-button
        label="Confirmer"
        icon="pi pi-check"
        (click)="confirmDedicatedAccountNameSelection()"
        severity="contrast"
        [disabled]="clientLabel === ''"
      ></p-button>
    </p-footer>
  </p-dialog>
  <p-dialog
    header="Installer Overlayer sur les lecteurs partagés sélectionnés"
    [(visible)]="openDialogs.installOnSharedDrives"
    [modal]="true"
    [draggable]="false"
    [style]="{ width: '70%', height: '80%' }"
  >
    <div>
      Sélectionnez/désélectionnez les lecteurs partagés sur lesquels Overlayer
      doit être installé
    </div>

    <div class="custom-margin">
      <p-multiSelect
        [options]="authorizedDrives"
        [(ngModel)]="selectedAuthorizedDrives"
        [loading]="isAuthorizedDrivesLoading"
        (onClear)="clearFilter()"
        placeholder="Sélectionnez les Drives"
        optionLabel="name"
        display="chip"
        [overlayVisible]="isLoaded"
        [ngModelOptions]="{ standalone: true }"
      >
      </p-multiSelect>
    </div>
    @if (!isInstallingOnSharedDrives) {
      <p-footer class="custom-footer">
        <p-button
          label="Annuler"
          icon="pi pi-times"
          class="p-button-secondary"
          severity="contrast"
          (click)="toggleDialog('installOnSharedDrives', false)"
        ></p-button>
        <p-button
          label="Confirmer"
          icon="pi pi-check"
          (click)="installOnSharedDrives()"
          severity="contrast"
        ></p-button>
      </p-footer>
    }

    @if (isInstallingOnSharedDrives) {
      <p-progressSpinner
        ariaLabel="loading"
        class="spinner-container"
      ></p-progressSpinner>
    }
  </p-dialog>
  <p-dialog
    header="Dernière étape avant de démarrer 🎯"
    [(visible)]="openDialogs.checkDriveLabels"
    [modal]="true"
    [style]="{ width: '50%' }"
    [closable]="false"
  >
    <div class="dialog-content">
      <p>
        Google demande une validation manuelle pour activer les labels dans
        Drive. Nous avons configuré les labels. Il ne vous reste plus qu'à
        activer les labels suivants dans la Google Admin Console.
      </p>
      <p-button
        label="Voir le guide pas à pas"
        icon="pi pi-file"
        (click)="
          redirectTo(
            'https://docs.overlayer.ai/guide-admin/etape-4-activation-manuelle-des-labels-sur-le-drive'
          )
        "
      />
      <p>Liste des labels à activer:</p>
      <ul>
        @for (label of labels; track label) {
          <li>
            <a
              [href]="'https://admin.google.com/u/1/ac/dc/labels/' + label.id"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ label.name }}
            </a>
          </li>
        }
      </ul>
    </div>
    <div class="dialog-footer">
      <p-button
        label="J’ai activé les labels"
        icon="pi pi-wrench"
        (click)="toggleDialog('checkDriveLabels', false); navigateToSettings()"
      ></p-button>
    </div>
  </p-dialog>
</app-loading-component>
